import { Component, DestroyRef, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner'; // Importing the module here
import { NotificationDisplayComponent } from './after-login/components/notification-display/notification-display.component';
import { RouteFlightService } from './services/route-listner/route-flight.service';
import { RouteHotelService } from './services/route-listner/route-hotel.service';
import { Store } from '@ngrx/store';
// import { loadGoogleMapsApiKey } from './after-login/store/apiKey.action';
import { loadTaxType } from './after-login/store/tax/tax.action';
import { AuthService } from './services/auth.service';
// import { TourService } from './services/tour.service';
import { filter, interval } from 'rxjs';
import { RouteListnerMarketplaceService } from './services/router-listner/route-listner-marketplace.service';
import { TourService, TourStepTemplateComponent } from 'ngx-ui-tour-primeng';
import { AppTourService } from './services/app-tour.service';
import { ButtonModule } from 'primeng/button';
// import { TranslationService } from './services/translation.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GeneralReminderDrawerComponent } from './after-login/components/shared/general-reminder-drawer/general-reminder-drawer.component';
import { PrimeNG } from 'primeng/config';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslationService } from './services/translation.service';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    NgxSpinnerModule,
    NotificationDisplayComponent,
    ButtonModule,
    TourStepTemplateComponent,
    TranslateModule,
    CommonModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'syncinns';
  public router: Router = inject(Router);
  //  private tourService: TourService = inject(TourService);
  // private flightRouteListener = inject(RouteFlightService);
  // private hotelRouteListener = inject(RouteHotelService);
  // private markethotelListner = inject(RouteListnerMarketplaceService);
  private authService: AuthService = inject(AuthService);
  private store = inject(Store);
  public appTourService = inject(AppTourService);
  public tourService = inject(TourService);
  private primeNG = inject(PrimeNG);
  private translate = inject(TranslateService);
  private destroyRef = inject(DestroyRef);
  private translationService = inject(TranslationService);
  private userRole: string | null;

  private swUpdate = inject(SwUpdate);

  private channel!: BroadcastChannel;
  public currentUrl: string = '';

  get showPostLoginUi(): boolean {
    return this.currentUrl.startsWith('/syncinns-pms');
  }

  constructor() {
    this.currentUrl = this.router.url;
    this.router.events.subscribe((routes) => {
      if (routes instanceof NavigationEnd) {
        this.currentUrl = routes.url;
        console.log('this.currentUrl', this.currentUrl);
      }
    });
    this.userRole = this.authService.getUserType();
  }

  ngOnInit(): void {
    const currentLanguage = this.translationService.currentLang;
    if (this.translate.getCurrentLang() !== currentLanguage) {
      this.translate.use(currentLanguage);
    }


    // Service Worker Update Handling
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          filter(
            (event): event is VersionReadyEvent =>
              event.type === 'VERSION_READY'
          )
        )
        .subscribe(async () => {
          const shouldUpdate = confirm(
            this.translate.instant('common.newVersion')
          );

          if (shouldUpdate) {
            await this.swUpdate.activateUpdate();
            document.location.reload();
          }
        });

      // Check for updates every 30 minutes
      interval(30 * 60 * 1000)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.swUpdate.checkForUpdate();
        });
    }


    this.translate
      .stream('primeng')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((translation) => {
        if (translation && typeof translation === 'object') {
          this.primeNG.setTranslation(translation);
        }
      });

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.action === 'navigate') {
          const targetUrl = event.data.url;
          console.log('SW navigation request:', targetUrl);

          // ✅ Use Angular Router for SPA navigation
          this.router.navigateByUrl(targetUrl);
        }
      });
    }

    if (this.authService.isAuthenticated()) {
      this.store.dispatch(loadTaxType());
    }
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.appTourService.stopTour();
      }
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }


  ngOnDestroy() {
    if (this.channel) {
      this.channel.close();
    }
  }
}
